module.exports = __webpack_public_path__ + "img/google-logo.5ac6bef5.png";